import React, {useState} from 'react';
import {useStores} from './App';
import Select from "react-select";
import {Observer} from "mobx-react-lite";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch, faTimes, faCog, faMap} from "@fortawesome/free-solid-svg-icons";
import ReactDatePicker from "react-datepicker";
import Tippy from "@tippyjs/react";
import {sticky} from 'tippy.js';
import {SearchItem} from 'ocs-search-commons';

export const Buscador = () => {

  const {appStore, searchTermsStore, stateQueryStore} = useStores();
  const [showAdvancedOptions, setAdvancedOptions] = useState(false);
  const toggleAdvancedOptions = () => setAdvancedOptions(s => !s);

  return (<div className='p-4 mt-3 bg-gray-200 border border-gray-300 rounded-lg'>
    <div className="flex items-center justify-between px-3 pb-3">
      <h1 className="text-2xl font-bold tracking-wider">Archivo</h1>
      <Observer>
        {() => <div className="ml-auto mr-2">Última actualización: <span
          className="font-bold">{appStore.lastUpdate}</span></div>}
      </Observer>
      <FontAwesomeIcon icon={faCog} title="Opciones avanzadas"
                       className="text-gray-500 cursor-pointer hover:text-gray-700"
                       onClick={toggleAdvancedOptions}/>
    </div>
    <div className='p-4 tracking-wide'>
      <Observer>
        {() => <p className="mb-4">
          El archivo contiene material hemerográfico de tres medios de comunicación. Está integrado por {appStore.notaCount} notas
          periodísticas relacionadas con megaproyectos extractivos a nivel nacional y abarcan el periodo comprendido
          entre el 1° de enero de 2017 al {appStore.lastUpdate}. Este archivo permite el acceso a las notas de La Jornada
          alojadas en su portal de internet. En el caso de las notas de El Reforma y de la revista Proceso no es
          posible, debido a las políticas de estos medios.
        </p>
        }
      </Observer>
    </div>
    <div className='flex'>
      <div className='px-3 pb-3'>
        <Observer>{() =>
          <ReactDatePicker
            className='flex-grow w-full p-1 border'
            selected={appStore.fechaInicio}
            onChange={d => appStore.setFechaStart(d)}
            maxDate={appStore.fechaFin}
            isClearable
            locale='es'
            dateFormat="MM/yyyy"
            showMonthYearPicker
            placeholderText='Fecha inicio'/>
        }</Observer>
      </div>
      <div className='px-3 pb-3'>
        <Observer>{() =>
          <ReactDatePicker
            selected={appStore.fechaFin}
            className='flex-grow w-full p-1 border'
            onChange={d => appStore.setFechaEnd(d)}
            minDate={appStore.fechaInicio}
            isClearable
            locale='es'
            dateFormat="MM/yyyy"
            showMonthYearPicker
            placeholderText='Fecha fin'/>
        }</Observer>
      </div>
    </div>
    <Observer>
      {() =>
        <div className='flex flex-wrap'>
          {searchTermsStore.itemsBusqueda.map((item, i) => <SelectControl item={item}
                                                                          showAdvancedOptions={showAdvancedOptions}
                                                                          key={i}/>)}
        </div>
      }
    </Observer>

    <div className="flex flex-wrap items-center justify-start px-3">
      <div className="px-4 py-2 mr-2 font-bold text-white bg-blue-500 rounded cursor-pointer hover:bg-blue-700"
           onClick={() => appStore.doSearch()}>
        Buscar
        <FontAwesomeIcon icon={faSearch} className="ml-2"/>
      </div>
      <Observer>
        {() => <a className="px-4 py-2 mr-2 font-bold text-white bg-green-500 rounded hover:bg-green-700"
                  href={`/ocs/?${stateQueryStore.serializedState}`} target="_blank" rel="noopener noreferrer">
          Ver en mapa
          <FontAwesomeIcon icon={faMap} className="ml-2"/>
        </a>
        }
      </Observer>
      <div className="px-4 py-2 mr-2 font-bold text-white bg-red-400 rounded cursor-pointer hover:bg-red-500"
           onClick={() => appStore.clearSearch()}>
        Limpiar
        <FontAwesomeIcon icon={faTimes} className="ml-2"/>
      </div>
      <Observer>
        {() => appStore.didSearch ?
          <div className='px-2 ml-auto mr-0'><span className="font-bold">{appStore.searchResults.length} </span>Nota(s)
          </div> : <></>}</Observer>
    </div>
  </div>)
};

type SelectControlProps = {
  item: SearchItem,
  showAdvancedOptions: boolean
}

const SelectControl = ({item, showAdvancedOptions}: SelectControlProps) => {

  const {searchStore, searchTermsStore} = useStores();

  return <div className='w-1/3 px-3 pb-3'>
    <Observer>
      {() =>
        <div className='flex items-center'>
          <div className="flex-grow min-w-0">
            <Select
              options={searchTermsStore.searchItemsByCategory[item.nombre]}
              isSearchable
              value={searchStore.selectStates.get(item.nombre)}
              placeholder={item.nombre}
              isMulti
              onChange={value => searchStore.selectItem(item.nombre, value)}
            />
          </div>
          {showAdvancedOptions ?
            <div className="flex flex-row flex-none w-12">
              <Tippy
                content='Muestra únicamente el o los resultados que cumplan con todas las variables de búsqueda seleccionadas.'
                placement='bottom'
                animation='scale'
                theme='light'
                plugins={[sticky]}>
                <div className={'ml-3 cursor-pointer uppercase border rounded-l border-gray-400 p-1 text-center ' +
                `${searchStore.logicOpForCat(item.nombre) === 'y' ? 'bg-green-200' : ''}`}
                     style={{width: '1.5rem'}}
                     onClick={() => searchStore.setQueryJoinType('y', item.nombre)}> Y
                </div>
              </Tippy>
              <Tippy
                content='Muestra los resultados que cumplan con al menos una de las variables de búsqueda seleccionadas.'
                placement='bottom'
                animation='scale'
                theme='light'
                plugins={[sticky]}>
                <div
                  className={'cursor-pointer uppercase border-r border-t border-b rounded-r border-gray-400 p-1 text-center ' +
                  `${searchStore.logicOpForCat(item.nombre) === 'o' ? 'bg-green-200' : ''}`}
                  style={{width: '1.5rem'}}
                  onClick={() => searchStore.setQueryJoinType('o', item.nombre)}>O
                </div>
              </Tippy>
            </div>
            : null
          }
        </div>
      }
    </Observer>
  </div>
};
